export default {
  frontpage: {
    petition: 'Opprop',
    do_not_want_to_sign: 'Jeg vil ikke skrive under',
    show_one_time_help_page: 'vis engangsinstruksjoner for å hjelpe',
  },
  feedback: {
    title: 'Svaret på din mening',
    subTitle: 'Fortell hvordan bedriften reagerte og svarte',
    thanksForSharing: 'Takk for at du deler!',
    done: 'Ferdig.',
    btnMoreNow: 'Jeg vil gjøre mer nå',
    btnMoreLater: 'Jeg vil gjøre mer senere',
    btn_skip: 'Hopp over',
    form: {
      placeholder: 'Svar mottatt',
    },
  },
  return: {
    title: 'Vent litt...',
  },
  claims: {
    nextButton: 'Enig',
    skipButton: 'Hopp over',
  },
  share: {
    title: 'Del nyhetene',
    description: 'Din deling vil nå inspirere dine venner, bekjente, kolleger og familie til å bli med i kampen for å stoppe lidelsen til dyrene, akkurat som deg. Vi vet allerede fra tidligere at det fungerer – dine handlinger kan inspirere andre til handling!',
    btnShareWith: 'Del med {platform}',
    btnShareLater: 'Jeg ønsker å dele senere',
    email: {
      subject: 'Hjelp oss å stoppe lidelsen til kyllingene',
      body: 'Hei, jeg har nettopp signert en kampanje for å stoppe lidelsen til kyllingene. Jeg håper du også vil være med å hjelpe. {link}',
    },
    tipsAndTricks: {
      title: 'Tips og triks',
      text1: 'Det er alltid best å <b>dele direkte</b> til en bestemt person.',
      text2: 'Når du deler, ikke glem å nevne dine <b>personlige grunner</b> til at du fordømmer praksisen og likegyldigheten til dyrs lidelse.',
      text3: 'Når du deler, ikke glem å nevne at <b>du allerede har signert</b> (evt. donerer)!',
      text4: 'Personlige <b>historier fungerer</b>, så snakk om dine følelser, verdier og tro.',
    },
  },
  org_contact: {
    title: 'Si din mening',
    subTitle: 'Forandring er ikke mulig uten deg {name}',
    description: 'Tidligere var det forbrukernes stemme som sørget for at bedriftene forpliktet seg til å slutte med egg fra burhøns. Bedriftene er interesserte i kundenes meninger. Skriv til dem og vis din misnøye.',
    // actionTitle: 'Skriv til bedriftene',
    whyCompany: 'Hvorfor {company}?',
    save_progress: 'Bekreft handling',
    warning: {
      title: 'Viktig!',
      description: 'Bruk dine egne ord. For at bedriften skal forstå at dette er viktig for deg så er det viktig at du skriver en personlig melding. Du kan gjerne bruke eksemplene som inspirasjon, men ikke kopier de direkte.',
    },
    whyCompanyModal: {
      title: 'Hvorfor fokuserer vi på {company}?',
      description: 'Vi velger våre mål med omhu og nøyaktighet.',
      actionButton: 'Jeg vil hjelpe dyrene',
    },
    btnDone: 'Jeg er ferdig',
    btnLater: 'Jeg vil kontakte dem senere',
    sendEmail: {
      title: 'Send en e-post',
      are_you_done: 'Har du sent en e-post til {company}?',
      btnContactForm: 'Åpne kontaktskjema',
    },
    socialMedia: {
      title: 'Skriv på sosiale medier',
      are_you_done: 'Har du skrevet på sosiale medier til {company}?',
    },
    phone: {
      title: 'Ring bedriften',
      are_you_done: 'Har du ringt og snakket med {company}?',
      btn_call: 'Ring',
      btn_script: 'Manus forslag',
      script_title: 'Manus forslag',
      script_description: 'Du kan bruke dette som insperasjon til hva du skal si når du ringer.',
    },
    postcard: {
      title: 'Send et postkort',
      description: 'Finn fram et postkort og noen frimerker, deretter skriver du hvorfor du mener {company} bør droppe turbokylling og ta dyrevelferd mer seriøst. Addressen til {company} er: {address}',
      are_you_done: 'Har du sent et postkort til {company}?',
    },
  },
  people_contact: {
    title: 'Skriv til stortingsrepresentantene',
    description: 'Sørg for at brevet er personlig, og når du har skrevet til alle, klikker du på «Sendt alle brev». Dette vil bidra til å organisere de neste trinnene for å stenge pelsfarmer i Litauen så snart som mulig.',
    your_district: 'Ditt valgdistrikt er {district}.',
    btn_change_district: 'Endre valgdistrikt',
    btn_change_people: 'endre politikere',
    affiliation: 'Parti',
    position: 'Posisjon',
    email: 'E-post',
    is_email_sent: 'Har du sent eposten?',
    btn_done: 'Jeg har skrevet til alle!',
    btn_later: 'Jeg vil skrive senere',
    btn_change_person: 'Bytt politiker',
  },
  people_district: {
    title: 'Velg ditt valgdestrikt',
    description: 'Velg fylket eller byen der du skal stemme. Basert på dette vil vi vise deg hvilken stortingsrepresentant som er valgt i din valgdestrikt.',
    btn_skip: 'Jeg kjenner ikke distriktet mitt, jeg vil hoppe over',
    btn_save: 'Lagre ditt valg og fortsett',
  },
  people_list: {
    title: 'Velg politikere - prioriter de på toppen',
    description: 'Øverst på listen er de medlemmene av Seimas som trenger brevet ditt mest. Vi anbefaler å velge minst 5 medlemmer av stortinget.',
    btn_reset: 'Tilbakestil valgte personer',
    btn_Save: 'Lagre valg og fortsett',
    btn_select_random: 'Velg tilfeldige',
  },
  people_choose: {
    title: 'Hvordan vil du velgere stortingsrepresentanter?',
    description: 'Du kan velge fritt eller skrive til de som trenger ditt ord mest.',
    btn_choose_any: 'Jeg vil velge politikere selv',
    btn_choose_for_me: 'Jeg vil skrive til de fem personene som trenger det mest',
    btn_skip: 'Jeg vil bare dele kampanjen',
  },
  thanks: {
    title: 'Takk for at du står opp for dyrene {name}!',
    text1: 'Du er ferdig for nå, men pass på. Dyrene vil snart <b>trenge deg mer enn noen gang</b>. Takk for at du står ved dem!',
    text2: 'Det er bare på grunn av mennesker som deg at dyrene har et <b>håp om en fremtid fri for lidelse</b>. Folk som deg forandrer verden. I løpet av de neste dagene og ukene vil jeg kontakte deg fortløpende. Sammen kan vi <b>endre livene til millioner av dyr!</b>',
    dontForgetToFollow: 'Ikke glem å følg oss på',
    goToPage: 'Vil du gå tilbake til en side?',
    btnWrite: 'Skriv for dyrene',
    btnShare: 'del kampanjen',
    btnDonate: 'gi et bidrag',
  },
  confirmEmail: {
    title: 'Bekreft e-posten din',
    description: 'Reisen din er ikke over ennå. Bekreft e-postadressen din nå. Klikk på lenken som allerede venter på deg i e-posten din {email}.',
    helpNotice: 'Finner du ikke e-posten? Sjekk søppelposten din. Ved problemer, skriv til oss på',
  },
  questions: {
    title: 'Jeg og turbokyllingene',
    description: 'Kyllingenes liv kan endres til det bedre. Turbokyllingene trenger ikke å lide store deler av livene sine. Flere bedrifter i Norge og andre steder i Europa har allerede implementert European Chicken Commitment (ECC) og dropper turbokylling. Hver eneste person som stiller seg på kyllingenes side er med på å drive frem endring.',
    btn_skip: 'Hopp over',
    btn_save: 'Lagre og fortsett',
    progress: 'Spørsmål fremgang',
  },
  unsubscribe: {
    title: 'Påminnelser er slått av',
    description: 'Du har nå slått av påminnelser, og du vil ikke få flere e-poster om denne kampanjen.',
    btnNext: 'Fortsett',
  },
  nin: {
    title: 'Skattefradrag',
    description: 'Om du i løpet av et kalender år gir 500 kr eller mer til oss har du rett på avdrag på din donasjon. Om du legger til ditt personummer her så vil vi ordne det slik at du automatisk får avdraget du har rett på.',
    nin: 'Fødselsnummer',
    btn_save: 'Lagre og fortsett',
    btn_skip: 'Hopp over',
  },
  donate: {
    title: ' Dyrene er avhengig av ditt bidrag {name}',
    description: 'Uten støtten til dyrevenner som deg, {name}, blir en fremtid fri for dyrs lidelse umulig å oppnå.',
    btnDonate: 'Doner',
    btnDonateLater: 'Jeg vil bidra senere',
  },
  error: {
    title: 'En feil har oppstått',
    text: 'Prøv igjen. Om problemet fortsetter kontakt oss på {email}',
    toFrontpageButton: 'Gå til forsiden',
  },
}
